import { Box, Chip, Tooltip } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';

interface LockedFeatureBadgeProps {
  children: React.ReactNode;
  planName?: string;
}

/**
 * Badge that wraps content and shows a "Pro" lock indicator.
 * Used for nav items and feature cards to proactively show locked status.
 *
 * Per CONTEXT.md: Show "Pro" badge or lock icon on gated features
 * before vendor attempts access (proactive discovery)
 */
export function LockedFeatureBadge({ children, planName = 'Pro' }: LockedFeatureBadgeProps) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
      {children}
      <Tooltip title={`Requires ${planName} plan`}>
        <Chip
          size="small"
          icon={<LockIcon sx={{ fontSize: 12 }} />}
          label={planName}
          sx={{
            ml: 1,
            height: 20,
            fontSize: '0.65rem',
            bgcolor: 'warning.light',
            color: 'warning.contrastText',
            '& .MuiChip-icon': {
              color: 'inherit',
            },
          }}
        />
      </Tooltip>
    </Box>
  );
}
